export interface Work {
  id: string;
  title: string;
  subtitle: string;
  type: 'movie' | 'tv' | 'variety';
  typeLabel: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  cover: string;
  backdrop: string;
  director: string;
  cast: string[];
  status: string;
  synopsis: string;
  story: string;
  views: number;
  featured: boolean;
  latest: boolean;
  topics: string[];
}

export interface Topic {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  cover: string;
  workIds: string[];
}

export const works: Work[] = [
  {
    id: 'w01',
    title: '沙海孤舟',
    subtitle: 'Sand Sea, Lonely Boat',
    type: 'movie',
    typeLabel: '电影',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '冒险'],
    rating: 8.7,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20poster%20of%20a%20lone%20wooden%20boat%20stranded%20on%20vast%20golden%20desert%20dunes%20at%20dusk%2C%20deep%20blue%20sky%2C%20warm%20orange%20light%2C%20lonely%20dramatic%20atmosphere%2C%20stylized%20art%2C%20high%20detail&width=400&height=600&seq=changri-w01-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=wide%20cinematic%20view%20of%20endless%20golden%20desert%20dunes%20under%20a%20deep%20blue%20twilight%20sky%20with%20a%20single%20abandoned%20wooden%20boat%2C%20warm%20orange%20rim%20light%2C%20epic%20lonely%20mood%2C%20stylized%20film%20still&width=1600&height=900&seq=changri-w01-back&orientation=landscape',
    director: '白凤岐',
    cast: ['秦砚舟', '陆云舒', '何澄'],
    status: '已上映',
    synopsis: '一艘搁浅在沙海里的旧船，牵出一段被风沙掩埋的往事。',
    story:
      '西北边陲的戈壁深处，考古队员信生意外发现一艘完整的木船埋在沙丘之下。随船出土的还有半本被水汽侵蚀的航海日志，记录着一段上世纪无人知晓的迁徙。\n\n为了解开谜团，信生找到当年护林员的后代阿依，两人沿着一串断断续续的坐标穿越无人区。随着沙暴逼近，真相也一层层浮现：这艘船并非迷路的意外，而是一群人为了守护某种承诺而选择的归途。',
    views: 1286000,
    featured: true,
    latest: false,
    topics: ['t-drive'],
  },
  {
    id: 'w02',
    title: '星轨之上',
    subtitle: 'Above the Star Tracks',
    type: 'movie',
    typeLabel: '电影',
    year: 2023,
    region: '中国大陆',
    genres: ['科幻', '悬疑'],
    rating: 8.3,
    cover:
      'https://readdy.ai/api/search-image?query=sci%20fi%20movie%20poster%20of%20a%20solitary%20astronaut%20silhouette%20against%20a%20swirling%20nebula%2C%20deep%20navy%20space%20background%2C%20orange%20and%20teal%20highlights%2C%20mysterious%20minimal%20composition%2C%20cinematic%20grade%2C%20high%20detail&width=400&height=600&seq=changri-w02-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20space%20scene%20with%20a%20giant%20orbital%20ring%20station%20above%20a%20blue%20planet%2C%20deep%20navy%20and%20orange%20color%20grading%2C%20lens%20flare%2C%20stylized%20science%20fiction%20film%20still%2C%20epic%20scale&width=1600&height=900&seq=changri-w02-back&orientation=landscape',
    director: '沈亦寒',
    cast: ['顾清野', '苏晚棠', '程昊'],
    status: '已上映',
    synopsis: '当星轨偏离了预定的弧线，一名工程师开始怀疑整个宇宙的坐标。',
    story:
      '轨道工程师范清河在例行巡检中发现，空间站外一条维持二十年的星轨出现了无法解释的偏移。按照物理模型，它本不该发生变化。\n\n他向上级递交报告，却被要求删除数据。与此同时，一名来自地面的记者递上了一份匿名档案，里面记录着同样的偏差。当两人试图拼合线索时，一个关于观测者与真相的猜想逐渐逼近——也许被改变的从来不是星星。',
    views: 964000,
    featured: true,
    latest: false,
    topics: ['t-scifi'],
  },
  {
    id: 'w03',
    title: '春潮漫城',
    subtitle: 'Spring Tide Over the City',
    type: 'movie',
    typeLabel: '电影',
    year: 2024,
    region: '中国大陆',
    genres: ['爱情', '剧情'],
    rating: 7.9,
    cover:
      'https://readdy.ai/api/search-image?query=romantic%20film%20poster%20of%20two%20figures%20walking%20under%20a%20city%20bridge%20in%20spring%20rain%2C%20soft%20orange%20streetlights%2C%20deep%20blue%20evening%2C%20tender%20warm%20mood%2C%20stylized%20cinematic%20art%2C%20high%20detail&width=400&height=600&seq=changri-w03-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20city%20street%20at%20dusk%20with%20cherry%20blossom%20petals%20floating%20in%20warm%20orange%20light%2C%20deep%20blue%20twilight%20sky%2C%20rain%20slicked%20pavement%20reflections%2C%20romantic%20film%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w03-back&orientation=landscape',
    director: '林知夏',
    cast: ['温以宁', '江叙白', '许择'],
    status: '已上映',
    synopsis: '一座城，一场漫过堤岸的春潮，和两个错过又重逢的人。',
    story:
      '建筑师温以宁回到阔别十年的南方小城主持旧桥改造，却在施工现场遇见了当年不告而别的初恋江叙白。两人默契地回避过去，却在一次次雨天测绘中重新熟悉彼此。\n\n春汛将至，老桥面临拆除。围绕保护的方案，两人产生了激烈的分歧，也终于被迫面对当年分开的真正原因。当潮水漫过城市最低处，他们才发现，有些告别从不是结束。',
    views: 812000,
    featured: false,
    latest: true,
    topics: [],
  },
  {
    id: 'w04',
    title: '雾都迷局',
    subtitle: 'Mist Capital',
    type: 'movie',
    typeLabel: '电影',
    year: 2022,
    region: '中国香港',
    genres: ['悬疑', '犯罪'],
    rating: 8.5,
    cover:
      'https://readdy.ai/api/search-image?query=noir%20crime%20film%20poster%20of%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20thick%20fog%20under%20a%20streetlamp%2C%20deep%20blue%20night%2C%20orange%20glow%2C%20tense%20mysterious%20mood%2C%20stylized%20cinematic%20art&width=400&height=600&seq=changri-w04-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20neon%20lit%20harbor%20city%20street%20covered%20in%20thick%20fog%20at%20night%2C%20deep%20blue%20tones%20with%20orange%20neon%20reflections%2C%20noir%20crime%20film%20still%2C%20high%20detail%2C%20moody%20atmosphere&width=1600&height=900&seq=changri-w04-back&orientation=landscape',
    director: '麦兆庭',
    cast: ['关世昌', '黎若彤', '邓景行'],
    status: '已上映',
    synopsis: '一桩没有尸体的命案，把警探推入城市最深的雾里。',
    story:
      '重案组警探关世昌接手一桩离奇案件：报案人称亲眼看见有人坠海，可打捞队翻遍海面也一无所获。唯一的线索是一枚被海水泡烂的袖扣。\n\n随着调查深入，案件牵出一张横跨码头、旧区与金融圈的灰色网络。每一名证人都说了真话，却拼不出完整的真相。当浓雾第七次笼罩港口，关世昌终于意识到，他要找的凶手，也许从未离开过这座城市。',
    views: 1105000,
    featured: false,
    latest: false,
    topics: ['t-mystery'],
  },
  {
    id: 'w05',
    title: '山鬼谣',
    subtitle: 'Ballad of the Mountain Spirit',
    type: 'movie',
    typeLabel: '电影',
    year: 2023,
    region: '中国大陆',
    genres: ['奇幻', '古装'],
    rating: 8.1,
    cover:
      'https://readdy.ai/api/search-image?query=fantasy%20chinese%20period%20film%20poster%20of%20a%20figure%20in%20traditional%20robes%20standing%20before%20misty%20mountains%2C%20deep%20blue%20and%20warm%20orange%20lantern%20light%2C%20ethereal%20mood%2C%20stylized%20ink%20painting%20style%2C%20high%20detail&width=400&height=600&seq=changri-w05-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=mystical%20ancient%20chinese%20mountain%20valley%20shrouded%20in%20mist%20with%20floating%20lanterns%2C%20deep%20blue%20night%20and%20warm%20orange%20glow%2C%20ink%20painting%20inspired%20cinematic%20still%2C%20ethereal%20fantasy%20atmosphere&width=1600&height=900&seq=changri-w05-back&orientation=landscape',
    director: '姜疏影',
    cast: ['萧承砚', '阮青禾', '白露'],
    status: '已上映',
    synopsis: '一首流传千年的山野歌谣，藏着人与山灵的旧约。',
    story:
      '采药女阮青禾在一次迷路中听见了山谷里反复回荡的歌谣，从此再也没能忘记那个旋律。村中老者说，那是山鬼的邀约，听见的人必会被带走。\n\n为了找回失踪的阿弟，青禾独自进入禁地。她遇见了自称守山人的神秘男子萧承砚，却发现对方与传说中山鬼的来历息息相关。当歌谣最后一次响起，青禾必须在自己与整座大山之间做出选择。',
    views: 735000,
    featured: false,
    latest: true,
    topics: [],
  },
  {
    id: 'w06',
    title: '第七个夏天',
    subtitle: 'The Seventh Summer',
    type: 'movie',
    typeLabel: '电影',
    year: 2021,
    region: '中国大陆',
    genres: ['剧情', '家庭'],
    rating: 8.0,
    cover:
      'https://readdy.ai/api/search-image?query=warm%20family%20drama%20film%20poster%20of%20a%20child%20and%20an%20elderly%20man%20sitting%20by%20a%20countryside%20river%20at%20sunset%2C%20soft%20orange%20light%2C%20deep%20blue%20sky%2C%20nostalgic%20gentle%20mood%2C%20stylized%20cinematic%20art&width=400&height=600&seq=changri-w06-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=nostalgic%20rural%20landscape%20with%20a%20small%20village%20by%20a%20winding%20river%20at%20golden%20sunset%2C%20warm%20orange%20tones%20and%20deep%20blue%20dusk%20skies%2C%20gentle%20family%20drama%20film%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w06-back&orientation=landscape',
    director: '周云樵',
    cast: ['宋怀安', '小满', '陈砚秋'],
    status: '已上映',
    synopsis: '每年夏天，爷爷都会在渡口等一个不会回来的人。',
    story:
      '七岁的小满被父母送回乡下爷爷家过暑假。村口的渡口旁，爷爷每天傍晚都会搬一把椅子坐一会儿，说是等人。小满起初不解，后来渐渐发现，那张椅子的方向正对着城里。\n\n这个夏天，小满跟着爷爷学会了修船、放灯和辨认星象，也慢慢读懂了大人们从未说出口的思念。当夏天结束，小满带着一个约定回到城市，而这个约定，要在很多年后才会兑现。',
    views: 690000,
    featured: false,
    latest: false,
    topics: ['t-warm'],
  },
  {
    id: 'w07',
    title: '逆锋',
    subtitle: 'Against the Edge',
    type: 'movie',
    typeLabel: '电影',
    year: 2024,
    region: '中国大陆',
    genres: ['运动', '励志'],
    rating: 7.6,
    cover:
      'https://readdy.ai/api/search-image?query=inspirational%20sports%20film%20poster%20of%20a%20young%20hockey%20player%20skating%20through%20ice%20spray%2C%20deep%20blue%20rink%20lighting%20with%20orange%20accent%2C%20dynamic%20energetic%20mood%2C%20stylized%20cinematic%20art%2C%20high%20detail&width=400&height=600&seq=changri-w07-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20ice%20hockey%20arena%20with%20dramatic%20deep%20blue%20lighting%20and%20orange%20spotlights%2C%20blurred%20motion%20and%20ice%20spray%2C%20energetic%20sports%20film%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w07-back&orientation=landscape',
    director: '高远',
    cast: ['凌野', '傅青', '孟辰'],
    status: '已上映',
    synopsis: '被退队的少年，在小城的冰场上重新学会滑行。',
    story:
      '天赋出众的少年凌野因伤被省队劝退，回到北方小城后自暴自弃。一次偶然，他被老教练傅青拉去给一群孩子当陪练。\n\n冰场即将因资金问题关闭，孩子们凑钱报名了业余联赛，只为给冰场争一口气。凌野起初嗤之以鼻，却在一次次摔倒和搀扶中重新找回了当初为什么热爱这项运动。当最后的哨声响起，输赢已经不再是最重要的事。',
    views: 588000,
    featured: false,
    latest: true,
    topics: [],
  },
  {
    id: 'w08',
    title: '长夜将明',
    subtitle: 'Dawn After the Long Night',
    type: 'tv',
    typeLabel: '电视剧',
    year: 2024,
    region: '中国大陆',
    genres: ['悬疑', '年代'],
    rating: 9.0,
    cover:
      'https://readdy.ai/api/search-image?query=period%20mystery%20tv%20poster%20of%20a%20lone%20figure%20in%20a%20long%20coat%20walking%20down%20a%20dim%20alley%20with%20old%20lamps%2C%20deep%20blue%20night%20and%20warm%20orange%20glow%2C%20tense%20cinematic%20mood%2C%20stylized%20art&width=400&height=600&seq=changri-w08-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20old%20town%20street%20at%20night%20in%20the%201940s%20with%20rain%20and%20orange%20lamp%20glow%2C%20deep%20blue%20shadows%2C%20period%20mystery%20tv%20series%20still%2C%20high%20detail%2C%20moody&width=1600&height=900&seq=changri-w08-back&orientation=landscape',
    director: '傅长庚',
    cast: ['靳怀远', '沈书言', '宋知微'],
    status: '更新至第 28 集 / 连载中',
    synopsis: '1947 年的雨夜，一桩旧案重新撕开了这座城。',
    story:
      '1947 年秋，警探靳怀远奉命调查一起发生在租界的坠楼案。死者随身携带的怀表里，藏着一张被剪去一半的照片。\n\n随着追查深入，案件与十五年前的一桩悬案逐渐重合，牵涉到码头、报社与一个早已解散的社团。报社记者沈书言为了寻找失踪的兄长主动接近靳怀远，两人从互相提防到并肩而行。长夜漫漫，他们要面对的不只是凶手，还有被时间掩埋的沉默。',
    views: 2138000,
    featured: true,
    latest: true,
    topics: ['t-mystery', 't-drive'],
  },
  {
    id: 'w09',
    title: '春风渡我',
    subtitle: 'Spring Breeze Crosses Me',
    type: 'tv',
    typeLabel: '电视剧',
    year: 2023,
    region: '中国大陆',
    genres: ['古装', '爱情'],
    rating: 8.2,
    cover:
      'https://readdy.ai/api/search-image?query=chinese%20period%20romance%20drama%20poster%20of%20a%20couple%20in%20elegant%20hanfu%20beneath%20blooming%20peach%20trees%2C%20soft%20warm%20orange%20light%20and%20deep%20blue%20sky%2C%20tender%20romantic%20mood%2C%20stylized%20art%2C%20high%20detail&width=400&height=600&seq=changri-w09-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=ancient%20chinese%20courtyard%20garden%20in%20spring%20with%20blooming%20peach%20blossoms%20and%20red%20lanterns%2C%20warm%20orange%20afternoon%20light%2C%20deep%20blue%20sky%2C%20romantic%20period%20drama%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w09-back&orientation=landscape',
    director: '柳如晦',
    cast: ['裴之遥', '温蘅', '祁昭'],
    status: '全 40 集 / 已完结',
    synopsis: '她带着一身医术远嫁边城，只为完成一桩早已作废的婚约。',
    story:
      '医女温蘅奉师命远赴边城，名义上是为人治病，实际上是为了了结一桩父辈定下、对方早已声明的作废婚约。她只想安静地做一名医者，却因一身过人医术卷入了地方势力的明争暗斗。\n\n守将裴之遥表面上冷淡疏离，暗地里却一次次为她挡下危机。两人从彼此利用到渐渐交付真心，在一场突如其来的疫病中并肩而立。春风年年渡人，而这一次，终于渡到了他们。',
    views: 1560000,
    featured: false,
    latest: false,
    topics: ['t-romance'],
  },
  {
    id: 'w10',
    title: '归途列车',
    subtitle: 'The Homebound Train',
    type: 'tv',
    typeLabel: '电视剧',
    year: 2024,
    region: '中国大陆',
    genres: ['都市', '剧情'],
    rating: 8.4,
    cover:
      'https://readdy.ai/api/search-image?query=urban%20drama%20tv%20poster%20of%20a%20railway%20worker%20at%20dusk%20beside%20a%20train%2C%20deep%20blue%20evening%20and%20warm%20orange%20station%20lights%2C%20quiet%20reflective%20mood%2C%20stylized%20cinematic%20art&width=400&height=600&seq=changri-w10-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20train%20station%20platform%20at%20dusk%20with%20departing%20train%20and%20warm%20orange%20lamps%2C%20deep%20blue%20sky%2C%20urban%20drama%20series%20still%2C%20high%20detail%2C%20quiet%20emotional%20mood&width=1600&height=900&seq=changri-w10-back&orientation=landscape',
    director: '闻亦明',
    cast: ['季川', '苏叶', '老周'],
    status: '更新至第 22 集 / 连载中',
    synopsis: '一条老铁路线停运前，四个人的命运在最后一班列车上交汇。',
    story:
      '华北小城的一条老铁路线即将停运。站长季川守着这座小站二十年，眼看最后一班列车驶过，也送走了一批又一批人。\n\n即将外出的实习生苏叶、返乡养老的退休工人老周、以及多年不曾回家的旅人，都登上了这趟列车。每个人的行囊里都装着一段未说出口的故事。列车穿行过平原与山谷，把他们的过往一点点串联起来。归途的意义，在到站前才逐渐清晰。',
    views: 1342000,
    featured: false,
    latest: true,
    topics: ['t-warm'],
  },
  {
    id: 'w11',
    title: '云上法庭',
    subtitle: 'Courtroom in the Cloud',
    type: 'tv',
    typeLabel: '电视剧',
    year: 2023,
    region: '中国大陆',
    genres: ['律政', '职场'],
    rating: 7.8,
    cover:
      'https://readdy.ai/api/search-image?query=legal%20drama%20tv%20poster%20of%20a%20young%20lawyer%20holding%20documents%20in%20a%20modern%20office%2C%20deep%20blue%20interior%20and%20warm%20orange%20desk%20light%2C%20clean%20sharp%20mood%2C%20stylized%20cinematic%20art&width=400&height=600&seq=changri-w11-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=modern%20high%20tech%20law%20office%20interior%20at%20night%20with%20city%20skyline%20through%20glass%2C%20deep%20blue%20tones%20and%20warm%20orange%20lamps%2C%20legal%20drama%20series%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w11-back&orientation=landscape',
    director: '方立群',
    cast: ['穆清和', '安棠', '魏明策'],
    status: '全 36 集 / 已完结',
    synopsis: '一家线上律所，一场关于技术与良知的博弈。',
    story:
      '互联网律所合伙人穆清和主推一套线上调解系统，试图让更多人用更低成本获得法律帮助。系统上线后，效率惊人，却接连卷入几起争议案件。\n\n年轻律师安棠质疑算法的判断，坚持要为一个被系统判定"无胜算"的当事人辩护。师徒二人理念碰撞，也各自面对内心的挣扎。当技术的高效与法律的温度发生冲突，他们必须回答一个问题：正义是否可以被打包成标准流程。',
    views: 902000,
    featured: false,
    latest: false,
    topics: [],
  },
  {
    id: 'w12',
    title: '半城烟火',
    subtitle: 'Half a City of Fireworks',
    type: 'tv',
    typeLabel: '电视剧',
    year: 2022,
    region: '中国大陆',
    genres: ['家庭', '生活'],
    rating: 8.6,
    cover:
      'https://readdy.ai/api/search-image?query=family%20life%20drama%20tv%20poster%20of%20a%20noodle%20shop%20family%20gathered%20for%20dinner%2C%20warm%20orange%20light%20and%20deep%20blue%20evening%20outside%2C%20heartwarming%20mood%2C%20stylized%20cinematic%20art&width=400&height=600&seq=changri-w12-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cozy%20old%20city%20street%20at%20night%20with%20glowing%20food%20stalls%20and%20warm%20orange%20lights%2C%20deep%20blue%20sky%2C%20heartwarming%20family%20drama%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w12-back&orientation=landscape',
    director: '何嘉树',
    cast: ['程守业', '周慧兰', '程小满'],
    status: '全 32 集 / 已完结',
    synopsis: '一家开了三十年的面馆，煮沸了半座城的家长里短。',
    story:
      '老城改造的消息传来，程家开了三十年的面馆面临拆迁。父亲程守业固执地不肯搬，母亲周慧兰忙着算账，女儿程小满则一心想去大城市闯荡。\n\n拆迁的倒计时里，街坊邻里、老主顾、还有多年不见的亲戚一个个上门。一碗面里盛着的，是争执、是和解、也是这座城最寻常的烟火。当推土机开进来那天，程家人终于明白，房子可以拆，但味道和牵挂留得住。',
    views: 1470000,
    featured: false,
    latest: false,
    topics: ['t-warm'],
  },
  {
    id: 'w13',
    title: '深海回响',
    subtitle: 'Echoes of the Deep',
    type: 'tv',
    typeLabel: '电视剧',
    year: 2024,
    region: '中国大陆',
    genres: ['科幻', '悬疑'],
    rating: 8.8,
    cover:
      'https://readdy.ai/api/search-image?query=deep%20sea%20sci%20fi%20tv%20poster%20of%20a%20submersible%20descending%20into%20dark%20ocean%20with%20glowing%20orange%20lights%2C%20deep%20blue%20abyss%2C%20mysterious%20tense%20mood%2C%20stylized%20cinematic%20art%2C%20high%20detail&width=400&height=600&seq=changri-w13-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=underwater%20sci%20fi%20scene%20of%20a%20deep%20sea%20research%20station%20with%20glowing%20orange%20lights%2C%20dark%20deep%20blue%20abyss%2C%20bioluminescent%20particles%2C%20tense%20cinematic%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w13-back&orientation=landscape',
    director: '宗衡',
    cast: ['聂沉', '祁雪', '简青'],
    status: '更新至第 18 集 / 连载中',
    synopsis: '海底传来一段规律的信号，它不该由任何已知的设备发出。',
    story:
      '深海研究所的潜航员聂沉在一次六千米下潜任务中，记录到一段规律而清晰的声音信号。经过分析，信号的编码方式竟与人类早期的通信协议高度相似。\n\n研究所内部对是否公开这一发现争执不下，值夜的工程师祁雪发现，类似信号在十年前就曾出现过，只是被归档封存。随着水下设备的异常、人员的神秘失踪，一组人不得不重新潜入那片黑暗。深海的回响，也许是一句迟到了太久的呼唤。',
    views: 1890000,
    featured: true,
    latest: true,
    topics: ['t-scifi', 't-mystery'],
  },
  {
    id: 'w14',
    title: '故里长安',
    subtitle: 'Old Home, Chang an',
    type: 'tv',
    typeLabel: '电视剧',
    year: 2023,
    region: '中国大陆',
    genres: ['历史', '剧情'],
    rating: 8.9,
    cover:
      'https://readdy.ai/api/search-image?query=epic%20historical%20chinese%20tv%20poster%20of%20a%20scholar%20in%20hanfu%20before%20grand%20palace%20gates%20at%20dusk%2C%20deep%20blue%20sky%20and%20warm%20orange%20lanterns%2C%20majestic%20solemn%20mood%2C%20stylized%20art%2C%20high%20detail&width=400&height=600&seq=changri-w14-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=grand%20ancient%20chinese%20palace%20at%20dusk%20with%20layered%20rooftops%20and%20warm%20orange%20lanterns%2C%20deep%20blue%20evening%20sky%2C%20epic%20historical%20drama%20still%2C%20high%20detail%2C%20majestic&width=1600&height=900&seq=changri-w14-back&orientation=landscape',
    director: '裴元朗',
    cast: ['谢知白', '宁婉', '陆沉舟'],
    status: '全 46 集 / 已完结',
    synopsis: '一介寒门书生，用三十年走完了从边城到长安的路。',
    story:
      '出身寒微的书生谢知白，凭着过人的才学一路科考，从遥远的边城走进长安。他以为只要恪守本心，便能在朝堂上有所作为，却发现理想与现实的差距远比想象中更大。\n\n数十年间，他历经贬谪、起复与至亲的离散，也见证了一座王朝的兴盛与暗流。故里早已回不去，长安也并非想象中的模样。当年那个背着书箱的少年，最终把一生的答案，写进了留给后人的一册奏疏里。',
    views: 1720000,
    featured: false,
    latest: false,
    topics: ['t-history'],
  },
  {
    id: 'w15',
    title: '山海厨房',
    subtitle: 'Kitchen Over Mountains and Seas',
    type: 'variety',
    typeLabel: '综艺',
    year: 2024,
    region: '中国大陆',
    genres: ['美食', '生活'],
    rating: 8.5,
    cover:
      'https://readdy.ai/api/search-image?query=food%20variety%20show%20poster%20of%20a%20rustic%20outdoor%20kitchen%20with%20fresh%20ingredients%20and%20steaming%20dishes%2C%20warm%20orange%20light%20and%20deep%20blue%20dusk%2C%20appetizing%20cozy%20mood%2C%20stylized%20art&width=400&height=600&seq=changri-w15-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=beautiful%20rustic%20outdoor%20kitchen%20by%20mountains%20with%20fresh%20colorful%20ingredients%20and%20steaming%20food%2C%20warm%20orange%20afternoon%20light%2C%20deep%20blue%20sky%2C%20food%20variety%20show%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w15-back&orientation=landscape',
    director: '节目组',
    cast: ['主持人 阿岚', '嘉宾 众星'],
    status: '更新至第 10 期 / 连载中',
    synopsis: '背着锅铲去山海之间，用一餐饭讲述一方水土。',
    story:
      '《山海厨房》每期走进一个不同的地方，从沿海渔村到高原牧场。主持人阿岚带着嘉宾就地取材，用最朴素的方式还原当地的时令风味。\n\n节目不追求复杂的技法，而是把镜头留给食材、灶火和围坐在一起的人。一餐饭做下来，观众看到的不只是味道，更是土地与人之间长久的默契。本季新增"深夜食堂"环节，记录每一道菜背后的普通人故事。',
    views: 1020000,
    featured: false,
    latest: true,
    topics: ['t-life'],
  },
  {
    id: 'w16',
    title: '声浪计划',
    subtitle: 'Project Soundwave',
    type: 'variety',
    typeLabel: '综艺',
    year: 2024,
    region: '中国大陆',
    genres: ['音乐', '竞演'],
    rating: 8.1,
    cover:
      'https://readdy.ai/api/search-image?query=music%20competition%20show%20poster%20of%20a%20singer%20silhouette%20on%20stage%20with%20orange%20spotlights%20and%20deep%20blue%20backdrop%2C%20energetic%20passionate%20mood%2C%20stylized%20cinematic%20art%2C%20high%20detail&width=400&height=600&seq=changri-w16-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=concert%20stage%20with%20dramatic%20orange%20spotlights%20and%20deep%20blue%20atmosphere%2C%20crowd%20silhouettes%20and%20haze%2C%20music%20competition%20show%20still%2C%20high%20detail%2C%20energetic&width=1600&height=900&seq=changri-w16-back&orientation=landscape',
    director: '节目组',
    cast: ['评委 三人组', '选手 众星'],
    status: '更新至第 8 期 / 连载中',
    synopsis: '不看资历看现场，用一首歌的时间改变命运。',
    story:
      '《声浪计划》是一档面向所有普通人的音乐竞演节目。选手来自各行各业，唯一的门槛是能不能在两百秒里打动评委。\n\n每期节目分为盲选、对战与改编三个环节，鼓励选手重新编曲与创作。舞台之外，镜头也记录着他们放弃的稳定生活与坚持的梦想。本季引入观众实时投票，让每一次现场都充满悬念。',
    views: 856000,
    featured: false,
    latest: false,
    topics: ['t-life'],
  },
  {
    id: 'w17',
    title: '漫游者说',
    subtitle: 'Words of a Wanderer',
    type: 'variety',
    typeLabel: '综艺',
    year: 2023,
    region: '中国大陆',
    genres: ['旅行', '人文'],
    rating: 8.7,
    cover:
      'https://readdy.ai/api/search-image?query=travel%20documentary%20variety%20poster%20of%20a%20lone%20backpacker%20on%20a%20winding%20mountain%20road%20at%20sunrise%2C%20deep%20blue%20sky%20with%20warm%20orange%20light%2C%20wanderlust%20serene%20mood%2C%20stylized%20art&width=400&height=600&seq=changri-w17-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=breathtaking%20mountain%20highway%20winding%20through%20mist%20at%20sunrise%2C%20deep%20blue%20shadows%20and%20warm%20orange%20light%2C%20travel%20documentary%20still%2C%20high%20detail%2C%20serene%20epic&width=1600&height=900&seq=changri-w17-back&orientation=landscape',
    director: '节目组',
    cast: ['主持人 陈迹', '各地讲述人'],
    status: '全 12 期 / 已完结',
    synopsis: '不赶路，只记录。走进那些地图上找不到名字的地方。',
    story:
      '《漫游者说》不设固定路线，主持人陈迹带着一台相机和一本笔记，随性地走向偏远的村落与小城。\n\n节目中，他拜访守着老手艺的匠人、开在悬崖边的驿站、以及一代代生活在古道旁的人家。没有刻意的煽情，只有安静地倾听和记录。每一期结束时，镜头都会留给当地的一句方言，作为旅程的收尾。',
    views: 1180000,
    featured: false,
    latest: false,
    topics: ['t-life'],
  },
  {
    id: 'w18',
    title: '妙手工坊',
    subtitle: 'The Clever Workshop',
    type: 'variety',
    typeLabel: '综艺',
    year: 2023,
    region: '中国大陆',
    genres: ['创意', '竞技'],
    rating: 7.9,
    cover:
      'https://readdy.ai/api/search-image?query=creative%20craft%20competition%20poster%20of%20hands%20building%20an%20intricate%20wooden%20model%20on%20a%20workshop%20table%2C%20warm%20orange%20desk%20light%20and%20deep%20blue%20background%2C%20focused%20inventive%20mood%2C%20stylized%20art&width=400&height=600&seq=changri-w18-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=creative%20workshop%20studio%20with%20makers%20building%20intricate%20models%20and%20tools%2C%20warm%20orange%20lighting%20and%20deep%20blue%20accents%2C%20craft%20competition%20show%20still%2C%20high%20detail&width=1600&height=900&seq=changri-w18-back&orientation=landscape',
    director: '节目组',
    cast: ['主持人 沈工', '选手 众匠'],
    status: '全 10 期 / 已完结',
    synopsis: '限时、限材料，看谁能把奇思妙想变成真家伙。',
    story:
      '《妙手工坊》把一群身怀绝技的创作者聚在一间工坊里，每期给出一个主题和一团有限的材料。\n\n选手们需要在规定时间内完成从设计到成品的全过程，评委则从创意、工艺与实用三个维度打分。有失败、有翻车，也有令人惊叹的巧思。节目最动人的地方在于，每一件作品背后，都是一个普通人对手艺的认真。',
    views: 623000,
    featured: false,
    latest: false,
    topics: [],
  },
];

export const topics: Topic[] = [
  {
    id: 't-mystery',
    title: '迷雾剧场 · 悬疑特辑',
    subtitle: 'Mystery Collection',
    description: '当真相藏进细节里，每一帧都值得反复推敲。精选高口碑悬疑作品，一起在迷雾中寻找出口。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20moody%20foggy%20city%20alley%20at%20night%20with%20orange%20streetlamp%20and%20deep%20blue%20shadows%2C%20mysterious%20tense%20atmosphere%2C%20stylized%20film%20still%2C%20high%20detail&width=1200&height=800&seq=changri-topic-mystery&orientation=landscape',
    workIds: ['w04', 'w08', 'w13'],
  },
  {
    id: 't-scifi',
    title: '星空与深海 · 科幻特辑',
    subtitle: 'Sci-Fi Collection',
    description: '从近地轨道到万米深渊，人类的好奇心从未停止。科幻迷不可错过的一组作品。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20blend%20of%20deep%20space%20nebula%20and%20dark%20ocean%20abyss%20with%20glowing%20orange%20particles%2C%20deep%20blue%20tones%2C%20epic%20science%20fiction%20concept%20art%2C%20high%20detail&width=1200&height=800&seq=changri-topic-scifi&orientation=landscape',
    workIds: ['w02', 'w13'],
  },
  {
    id: 't-warm',
    title: '人间烟火 · 治愈特辑',
    subtitle: 'Healing Collection',
    description: '慢下来的故事最动人。这里有一餐饭、一趟车、一个夏天，和一群认真生活的人。',
    cover:
      'https://readdy.ai/api/search-image?query=cozy%20warm%20evening%20village%20scene%20with%20glowing%20home%20windows%20and%20dinner%20smoke%2C%20warm%20orange%20light%20and%20deep%20blue%20dusk%20sky%2C%20heartwarming%20cinematic%20still%2C%20high%20detail&width=1200&height=800&seq=changri-topic-warm&orientation=landscape',
    workIds: ['w06', 'w10', 'w12'],
  },
  {
    id: 't-romance',
    title: '东方情书 · 古装特辑',
    subtitle: 'Period Romance',
    description: '长街灯火、庭院花开，那些含蓄又深情的东方爱情故事。',
    cover:
      'https://readdy.ai/api/search-image?query=ancient%20chinese%20garden%20at%20dusk%20with%20blooming%20peach%20blossoms%20and%20floating%20lanterns%20on%20a%20pond%2C%20warm%20orange%20light%20and%20deep%20blue%20sky%2C%20romantic%20period%20cinematic%20still%2C%20high%20detail&width=1200&height=800&seq=changri-topic-romance&orientation=landscape',
    workIds: ['w05', 'w09'],
  },
  {
    id: 't-history',
    title: '山河故人 · 历史特辑',
    subtitle: 'History Collection',
    description: '以大时代为幕布，讲述个体在历史洪流中的选择与坚守。',
    cover:
      'https://readdy.ai/api/search-image?query=epic%20ancient%20chinese%20city%20wall%20and%20palace%20rooftops%20at%20dusk%20with%20warm%20orange%20lanterns%2C%20deep%20blue%20sky%2C%20majestic%20historical%20cinematic%20still%2C%20high%20detail&width=1200&height=800&seq=changri-topic-history&orientation=landscape',
    workIds: ['w14', 'w08'],
  },
  {
    id: 't-life',
    title: '生活观察 · 综艺特辑',
    subtitle: 'Variety Collection',
    description: '美食、音乐、旅行与手作，总有一档节目能让你放松下来。',
    cover:
      'https://readdy.ai/api/search-image?query=vibrant%20lifestyle%20collage%20scene%20with%20food%2C%20musical%20stage%20and%20mountain%20travel%20elements%2C%20warm%20orange%20accents%20and%20deep%20blue%20tones%2C%20modern%20variety%20show%20still%2C%20high%20detail&width=1200&height=800&seq=changri-topic-life&orientation=landscape',
    workIds: ['w15', 'w16', 'w17'],
  },
];

export const regionOptions = [
  '全部',
  '中国大陆',
  '中国香港',
  '中国台湾',
  '美国',
  '日本',
  '韩国',
  '英国',
];

export const genreOptions: Record<string, string[]> = {
  movie: ['全部', '剧情', '科幻', '爱情', '悬疑', '犯罪', '奇幻', '古装', '运动', '家庭', '冒险'],
  tv: ['全部', '悬疑', '年代', '古装', '爱情', '都市', '剧情', '律政', '家庭', '科幻', '历史'],
  variety: ['全部', '美食', '生活', '音乐', '竞演', '旅行', '人文', '创意', '竞技'],
};

export const yearOptions = ['全部', '2024', '2023', '2022', '2021'];

export const typeMeta: Record<string, { label: string; title: string; description: string; banner: string }> = {
  movie: {
    label: '电影',
    title: '电影分类',
    description: '精选院线与口碑佳作，覆盖剧情、科幻、悬疑、爱情等多元类型，找到属于你的那一部。',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20warm%20orange%20movie%20theater%20with%20deep%20blue%20lighting%20and%20empty%20red%20seats%2C%20dramatic%20atmosphere%2C%20stylized%20film%20still%2C%20high%20detail&width=1600&height=500&seq=changri-banner-movie&orientation=landscape',
  },
  tv: {
    label: '电视剧',
    title: '电视剧分类',
    description: '连载与完结的热门剧集，悬疑、古装、都市、历史一网打尽，追剧党的收藏夹。',
    banner:
      'https://readdy.ai/api/search-image?query=cinematic%20living%20room%20at%20night%20with%20TV%20screen%20glow%20in%20warm%20orange%20and%20deep%20blue%20tones%2C%20cozy%20binge%20watching%20mood%2C%20stylized%20film%20still%2C%20high%20detail&width=1600&height=500&seq=changri-banner-tv&orientation=landscape',
  },
  variety: {
    label: '综艺',
    title: '综艺分类',
    description: '美食、音乐、旅行与手作，轻松治愈的综艺节目合集，随时打开随时放松。',
    banner:
      'https://readdy.ai/api/search-image?query=vibrant%20colorful%20tv%20variety%20studio%20stage%20with%20warm%20orange%20lights%20and%20deep%20blue%20backdrop%2C%20energetic%20playful%20mood%2C%20stylized%20film%20still%2C%20high%20detail&width=1600&height=500&seq=changri-banner-variety&orientation=landscape',
  },
};